import css from 'styled-jsx/css'

export default css`
  .form-container {
    margin: 1rem 0;
    padding: 0.5rem 1.5rem;
    text-align: left;
  }
  .form-container h3 {
    margin-top: 0;
  }
  .form-container p {
    margin-bottom: 0;
  }
  .container-button-control {
    margin-top: 1rem;
  }
`
export const msgModal = css`
  .message-container {
    padding: 1rem;
    text-align: center;
  }
  .image-bell-success {
    margin: 0 0 1.5rem 0;
    text-align: center;
  }
  .finish-button {
    text-align: center;
    margin: 1.5rem 0;
  }
`

export const reportFormStyles = css`
  .container-button-control {
    margin-top: 1rem;
  }
  .report-form {
    margin: 1rem 0;
    padding: 0.5rem 1.5rem;
    text-align: left;
  }
`
